/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Code_LabelInputs */

const en_password_reset_code_label = /** @type {(inputs: Password_Reset_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification code`)
};

const es_password_reset_code_label = /** @type {(inputs: Password_Reset_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de verificación`)
};

/**
* | output |
* | --- |
* | "Verification code" |
*
* @param {Password_Reset_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_code_label = /** @type {((inputs?: Password_Reset_Code_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Code_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_code_label(inputs)
	return en_password_reset_code_label(inputs)
});